import { RouteObject } from 'react-router-dom';
import DLTForm from '../components/DLTForm/DLTForm';

const dltFormRoute: RouteObject = {
  path: '/dlt-forms/:requestId',
  element: <DLTForm />,
};

export default dltFormRoute;
